import { render, staticRenderFns } from "./OwnerMessageTimeline.vue?vue&type=template&id=315c0ddf&"
import script from "./OwnerMessageTimeline.vue?vue&type=script&lang=js&"
export * from "./OwnerMessageTimeline.vue?vue&type=script&lang=js&"
import style0 from "./OwnerMessageTimeline.vue?vue&type=style&index=0&id=315c0ddf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports